angular.module('zc')
  .component('zcDomainSampler', {
    templateUrl: '/templates/projects/components/domain_sampler/domain_sampler.html',
    bindings: { project: '<' },
    controller: zcDomainSampler,
  });

zcDomainSampler.$inject = ['$filter', '$scope', '$window', 'MongoHistory'];
function zcDomainSampler($filter, $scope, $window, MongoHistory) {
  const vm = this;

  vm.from = moment().subtract(1, 'day').toDate();
  vm.to = moment().subtract(1, 'hour').toDate();
  vm.tableRows = [];
  vm.devices = [
    { name: $filter('translate')('projects.components.domainSampler.allDevice'), value: 'all' },
    { name: $filter('translate')('projects.components.domainSampler.pc'), value: 'pc' },
    { name: $filter('translate')('projects.components.domainSampler.sp'), value: 'sp' },
  ];
  if(vm.project.enable_app) {
    vm.devices.push({ name: $filter('translate')('projects.components.domainSampler.app'), value: 'app' });
  }
  vm.device = vm.devices[0];
  vm.$onInit = () => {
    $scope.$watch('$ctrl.device.value', onChangeDevice);
  };

  function onChangeDevice(device) {
    const query = buildQuery(device);
    MongoHistory.find(query)
      .then(histories => {
        const historyCount = histories.length;
        vm.tableRows = _.chain(histories)
          .groupBy(history => getHost(history.url))
          .map((matchHistories, domain) => {
            const matchCount = matchHistories.length;
            const matchRate = historyCount ? matchCount / historyCount * 100 : 0;
            return { domain, matchCount, matchRate };
          })
          .sortBy(row => -row.matchCount)
          .value();
      });
  }

  function buildQuery(device) {
    const query = {
      apikey: vm.project.apikey,
      opened_at: { $gte: vm.from, $lt: vm.to },
      is_exclude: false,
    };
    if(device === 'pc') {
      query.device = { $in: ['pc', 'tablet'] };
    } else if(device === 'sp') {
      query.device = 'sp';
    } else if(device === 'app') {
      query.device = 'app';
    }
    return query;
  }

  function getHost(url) {
    const anchor = $window.document.createElement('a');
    anchor.href = url;
    return anchor.host;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects/components/domain_sampler/domain_sampler.js